import { type ApplicationModes } from '../../constants/application-modes';

export const onKeyboardPress = (
	pressType: string,
	title: string,
	applicationMode: ApplicationModes,
) => {
	return {
		type: 'sendUIEvent',
		data: {
			actionSubject: 'keyboard',
			action: 'pressed',
			source: 'fullPageSearch',
			attributes: {
				pressType,
				title,
				mode: applicationMode,
			},
		},
	};
};

export const onHighlightedWithKeyboard = (index: number, applicationMode: ApplicationModes) => {
	return {
		type: 'sendUIEvent',
		data: {
			actionSubject: 'keyboard',
			action: 'highlighted',
			source: 'fullPageSearch',
			attributes: {
				index,
				mode: applicationMode,
			},
		},
	};
};
